export enum Endpoints {
  info = 'info',
  article = 'article',
  articles = 'articles',
  guide = 'guide',
  guides = 'guides',
  steps = 'steps',
  category = 'category',
  categories = 'categories',
  feedback = 'feedback',
  comments = 'comments',
  backendComments = 'backendComments',
  commentAction = 'commentAction',
  commentActionFrontend = 'commentActionFrontend',
  downloads = 'downloads',
  materials = 'materials',
  user = 'user',
  qrCode = 'qrCode',
  logout = 'logout',
  related = 'related',
  tooltips = 'tooltips',
  productPageContentBlocks = 'productPageContentBlocks',
  pdfs = 'pdfs',
  search = 'search',
  googleVertexSearch = 'googleVertexSearch',
  forumListTopics = 'forumListTopics',
  forumCategoryById = 'forumCategoryById',
  vertex = 'vertex',
  recaptcha = 'recaptcha',
  profiles = 'profiles',
}
